import React from 'react';
import { FaFacebook, FaInstagram, FaTiktok, FaWhatsapp, FaPhone } from 'react-icons/fa';

const iconSize = 32;
const SocialMediaData = [
    {
        id: 1,
        icon: <FaFacebook size={iconSize} />,
        link: 'https://www.facebook.com/people/AncyFriz-frizerski-studio/100088513466883/',
        title: 'Facebook'

    },
    {
        id: 2,
        icon: <FaInstagram size={iconSize}/>,
        link: 'https://www.instagram.com/ancyfriz_frizerski_studio/',
        title: 'Instagram'
    },

    {
        id: 3,
        icon: <FaTiktok size={iconSize}/>,
        link: 'https://www.tiktok.com/@ancyfriz',
        title: 'TikTok'
    },
    {
        id: 4,
        icon: <FaWhatsapp size={iconSize}/>,
        link: 'https://wa.me/38762741146',
        title: 'WhatsApp'
    },
    {
        id: 5,
        icon: <FaPhone size={iconSize}/>,
        link: 'tel:+38762741146',
        title: 'Call Us'
    },
];

export default SocialMediaData;